module.exports = __webpack_public_path__ + "assets/img/TrendingNow_Voyage.82c86d65-ps.jpg";